import React from 'react';
import { useRouter } from 'next/router';
import ImportantMessages from './ImportantMessages';
import ImportantMessageFallback from './ImportantMessageFallback';
import ContentoQuery, { ContentoError, ContentoData } from '../Contento/ContentoQuery';
import ImportantMessagesQuery from './ImportantMessages.graphql';

const ImportantMessagesContainer = ({ hasCookie }) => {
    const router = useRouter();

    return (
        <ContentoQuery
            key={router?.asPath}
            fetchPolicy="cache-and-network"
            query={ImportantMessagesQuery}
            queryTimeout={3000}
            isLoadingScreenEnabled={false}
        >
            <ContentoData>
                {(data) => <ImportantMessages messages={data.importantMessages} hasCookie={hasCookie} />}
            </ContentoData>

            <ContentoError>
                <ImportantMessageFallback />
            </ContentoError>
        </ContentoQuery>
    );
};

export default ImportantMessagesContainer;
